import type { SVGProps } from 'react';

type SVGRProps = {
  title?: string;
  titleId?: string;
};

export const MarketCredit = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M31.7615 32.0752C32.5452 29.1758 34.5906 26.7821 37.3323 25.5559L68.7952 11.4841C73.1319 9.54455 78.2346 10.9238 81.0036 14.784L101.093 42.7902C102.844 45.2307 103.405 48.3288 102.621 51.2282L87.7091 106.397C86.268 111.728 80.7778 114.882 75.4462 113.441L23.8939 99.5066C18.5624 98.0655 15.4086 92.5752 16.8497 87.2437L31.7615 32.0752Z"
      fill="url(#paint0_linear_7205_3978)"
      stroke="green"
    />
    <path
      d="M53.618 61.7683L40.6378 58.554L36.8267 52.2341L40.4331 37.6709L46.753 33.8599L59.7332 37.0742L63.5443 43.3941L59.9379 57.9573L53.618 61.7683ZM80.6282 42.2486L88.3055 44.1498L41.0232 89.5619L33.3459 87.6607L80.6282 42.2486ZM46.7709 41.9284L44.4189 51.4262L45.4313 53.1049L51.9214 54.7121L53.6001 53.6998L55.9521 44.202L54.9397 42.5233L48.4496 40.9161L46.7709 41.9284ZM81.0136 73.2566L84.8247 79.5764L81.2183 94.1396L74.8985 97.9507L61.9183 94.7363L58.1072 88.4164L61.7136 73.8533L68.0334 70.0422L81.0136 73.2566ZM73.2018 90.8944L74.8805 89.8821L77.2325 80.3844L76.2202 78.7056L69.7301 77.0985L68.0514 78.1108L65.6994 87.6085L66.7117 89.2872L73.2018 90.8944Z"
      fill="#050505"
    />
    <path
      d="M51.6766 61.2869L38.6964 58.0725L34.8853 51.7527L38.4917 37.1895L44.8116 33.3784L57.7918 36.5928L61.6029 42.9126L57.9965 57.4758L51.6766 61.2869ZM78.6868 41.7672L86.3641 43.6683L39.0818 89.0805L31.4045 87.1793L78.6868 41.7672ZM44.8295 41.447L42.4775 50.9447L43.4898 52.6234L49.98 54.2306L51.6587 53.2183L54.0107 43.7206L52.9983 42.0419L46.5082 40.4347L44.8295 41.447ZM79.0722 72.7751L82.8833 79.095L79.2769 93.6582L72.9571 97.4692L59.9769 94.2548L56.1658 87.935L59.7722 73.3718L66.092 69.5607L79.0722 72.7751ZM71.2604 90.413L72.9391 89.4006L75.2911 79.9029L74.2788 78.2242L67.7887 76.617L66.11 77.6293L63.758 87.1271L64.7703 88.8058L71.2604 90.413Z"
      fill="#282828"
    />
    <path
      d="M111.252 12.7152C109.91 10.6752 107.436 9.86495 105.581 9.4706C103.524 9.03345 101.155 8.89834 98.9476 8.89845C94.5188 8.89868 90.1664 9.4468 88.9625 9.65018C87.8322 9.84115 84.8195 10.4175 81.8138 11.1637C80.3129 11.5364 79.614 11.7183 78.2793 12.1764L79.7018 13.2989L82.7292 17.1735L83.2602 16.9868C86.0987 16.2821 88.9603 15.7361 89.9621 15.5669C90.891 15.41 94.9054 14.8988 98.9477 14.8986C100.976 14.8985 102.869 15.0286 104.334 15.34C106 15.6942 106.308 16.1166 106.24 16.0133C106.616 16.5839 106.62 16.8704 106.619 16.926C106.618 16.9835 106.603 17.1015 106.446 17.3239C106.041 17.8949 105.184 18.4765 104.183 18.9949C102.394 19.9212 96.4377 22.1067 91.2043 23.0557C86.2685 23.9508 80.1816 23.169 77.3399 22.4253C76.8939 22.3085 76.0646 21.7994 75.2944 20.8946C74.6201 19.9855 73.6574 19.2938 72.526 19.2606L72.126 19.2488C70.0488 19.1878 68.3366 20.9029 69.317 22.7351C69.7331 23.5126 70.2367 24.2103 70.7254 24.7844C71.9542 26.2279 73.7657 27.6925 75.8209 28.2304C79.2323 29.1231 86.2372 30.055 92.2754 28.96C98.0154 27.919 104.553 25.5601 106.942 24.3232C108.03 23.76 110.039 22.6305 111.342 20.7928C112.037 19.8115 112.587 18.5508 112.617 17.0463C112.648 15.5402 112.151 14.0812 111.252 12.7152Z"
      fill="url(#paint2_radial_7205_3978)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7205_3978"
        x1="104.949"
        y1="44.8939"
        x2="17.1269"
        y2="96.974"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDFF96" />
        <stop offset="1" stopColor="#B2EAC4" />
      </linearGradient>
      <radialGradient
        id="paint2_radial_7205_3978"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(92.8741 19.3845) rotate(165.896) scale(27.0145 45.3623)"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#737373" />
      </radialGradient>
    </defs>
  </svg>
);
